import { __decorate, __metadata } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import { applyTenantIdInterceptor } from 'library-components/config/authInterceptor';
import PtIcon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/ArrowLeft.svg';
import { getTenantDisabledTooltip } from 'library-components/utils/tenants';
import { Tooltip } from 'element-ui';
let MultiTenantImpl = class MultiTenantImpl extends Vue {
    constructor() {
        super(...arguments);
        this.tenantId = '';
    }
    setTenantId() {
        applyTenantIdInterceptor(this.tenantId);
    }
    onBack() {
        this.$emit('close', '1');
    }
    onSelectTenant(item) {
        if (this.getTooltip(item)) {
            return;
        }
        this.$emit('select', item);
    }
    getTooltip(item) {
        return getTenantDisabledTooltip(item, this.$i18n.locale);
    }
};
__decorate([
    Prop({ type: Array, default: () => [] }),
    __metadata("design:type", Array)
], MultiTenantImpl.prototype, "tenants", void 0);
MultiTenantImpl = __decorate([
    Component({
        name: 'MultiTenant',
        components: {
            PtIcon,
            ElTooltip: Tooltip,
        },
    })
], MultiTenantImpl);
export { MultiTenantImpl };
